module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./PromoteHomeView.js"));
	}, "PromoteHomeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PromoteHomeView!./src/pages/Promote/PromoteHome/PromoteHomeView.js
// module id = 1118
// module chunks = 431